<template>
  <div class="create-brand" v-cloak>
    <div class="container">
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <div key="1" v-if="loader" class="white-row loader-route">
          <div class="lds-sub-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else key="2" class="white-row">
          <div class="convert-leadto-client-form form-area">
            <form
              class="project-invoice-form"
              v-on:submit.prevent="submit($event)"
            >
              <div class="col-sm-12">
                <div class="row">
                  <div class="form-group">
                    <label for="invoice_status" class="control-label"
                      >Invoice Status<span>*</span></label
                    >
                    <Select2
                      v-model="formData.invoice_status"
                      :options="invoice_status_options"
                      :settings="{
                        placeholder: 'Select Invoice status'
                      }"
                      :class="{
                        'input-border-errors':
                          $v.formData.invoice_status.$dirty &&
                          !$v.formData.invoice_status.required
                      }"
                    />
                  </div>
                </div> 
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="form-actions">
                    <button
                      :disabled="disableSubmitBtn"
                      type="submit"
                      id="save-form"
                      class="default-global-btn"
                    >
                      Update Status
                    </button>
                    <div
                      v-if="disableSubmitBtn"
                      class="form_submit_loader"
                    >
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>


import { validationMixin } from "vuelidate";
const {
  required,
  minLength,
  email,
  numeric,
  url
} = require("vuelidate/lib/validators");

import Select2 from "v-select2-component";

export default {
  mixins: [validationMixin],
  name : "change-invoice-status-component",
  components: {
    Select2
  },
  watch: {
    prop_invoice_id: {
      handler(val){
        if(val) {
          this.loader = false;
        //   this.getInvoiceStatus();
        }
      },
      deep: true
    },
  },
  props: [
    'prop_invoice_id',
  ],
  validations: {
    formData: {
      invoice_status: {
        required
      },
    }
  },
  data() {
    return {
      disableSubmitBtn : false,
      loader: true,
      data_loader: true,
      formData: {
        invoice_id : null,
        invoice_status : null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      get_client_thread_listing: {},
      invoice_status_options: [
        {
          id: "paid",
          text: "Paid"
        },
        {
          id: "unpaid",
          text: "Unpaid"
        },
        {
          id: "refunded",
          text: "Refunded"
        }
      ],
    };
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  mounted() {
    this.loader = false;
    this.getInvoiceStatus();
  },
  methods: {
    async submit(event) {
      const $this = this;
      $this.disableSubmitBtn = true;
      $this.$v.$touch();

      if ($this.$v.$invalid) {
        $this.$store.dispatch("showtostrMessageNotifications", {
          message: "Please fill all the fields to proceed form!",
          type: "error"
        });
        $this.disableSubmitBtn = false;
        return;
      }

      const data = $this.$store.dispatch("postHttp", {
        url: "invoices/update-invoice-status",
        formDetails: this.formData,
        formEvent: event.target
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          // console.log(response.data.data);
          $this.$emit('get-data-from-sub',response.data.data);
          $this.$store.dispatch("showtostrMessageNotifications", {
            message: 'Status Updated',
            type: "success"
          });
        }
      });
      $this.disableSubmitBtn = false;
    },
    refreshBrandTable() {
      this.getInvoiceStatus();
    },

    async getInvoiceStatus() {
      const $this = this;
      $this.data_loader = true;
      const data = $this.$store.dispatch("getHttp", {
        url:
          "invoices/get-invoice-status/" +
          this.prop_invoice_id + 
          "?timezone=" +
          Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          console.log(response.data.data.status);
          $this.formData.invoice_id = response.data.data.id;
          $this.formData.invoice_status = response.data.data.status;
          $this.data_loader = false;
        }
      });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
  }
};
</script>
<style lang="scss" scoped>

.form-check {
    clear: both;
    margin-bottom: 20px;
}

</style>